import { defineStore, acceptHMRUpdate } from 'pinia'

interface Modal {
  name: string
  closeByEscape: boolean
}

interface State {
  modals: Modal[]
}

export const useModalStore = defineStore('modals', {
  state: (): State => ({
    modals: [] as Modal[],
  }),

  actions: {
    create ({ name, closeByEscape }: Modal) {
      this.modals = [...this.modals, { name: name, closeByEscape: closeByEscape }]
    },

    remove (name: string) {
      this.modals = this.modals.filter((m: Modal) => m.name !== name && m.closeByEscape)
    },
  },

  getters: {
    latestOpenModalName: (state: State) => state.modals[state.modals.length - 1]?.name as string | null
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useModalStore, import.meta.hot))
}
